export function Logo({ large }: { large?: boolean }) {
  return (
    <span className={large ? 'logo logo--lg' : 'logo'}>
      <img src="/logo-mark.png" alt="" aria-hidden="true" />
      <span>Lumnos</span>
    </span>
  );
}
